<template>
  <div class="schema">
    <script type="application/ld+json">{
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": [
            "FinancialService",
            "Organization"
          ],
          "@id": "https://getincome.com/#organization",
          "legalName":"Income Company OÜ",
          "name": "Income Company",
          "alternateName": "Income Marketplace",
          "url": "https://getincome.com/",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Maakri 19/2",
            "addressLocality": "Tallinn",
            "addressRegion": "Estonia",
            "postalCode": "10145",
            "addressCountry": "Estonia"
          },
          "foundingDate": "2020",
          "founders": [
            {
              "@type": "Person",
              "name": "Kimmo Rytkönen"
            },
            {
              "@type": "Person",
              "name": "Mikk Läänemets"
            }
          ],
          "logo": {
            "@type": "ImageObject",
            "url": "https://getincome.com/img/income-fb.jpg"
          },
          "openingHours": [
            "Monday,Tuesday,Wednesday,Thursday,Friday 10:00-17:00"
          ],
          "image": {
            "@type": "ImageObject",
            "url": "https://getincome.com/img/income-fb.jpg"
          },
          "telephone": "+44-116-464-9956",
          "sameAs": [
            "https://www.facebook.com/IncomeMarketplace/",
            "https://www.instagram.com/incomemarketplace/",
            "https://www.youtube.com/channel/UCnMcn1QXpSiPVfMz1gZObcA/",
            "https://www.linkedin.com/company/income-marketplace/"
          ],
          "contactPoint" : [
            { "@type" : "ContactPoint",
              "telephone" : "+44-116-464-9956",
              "contactType" : "customer service",
              "availableLanguage" : "English"
            },
            { "@type" : "ContactPoint",
              "telephone" : "+372-602-6813",
              "contactType" : "customer service",
              "availableLanguage" : "German"
            },
            { "@type" : "ContactPoint",
              "telephone" : "+372-660-0353",
              "contactType" : "customer service",
              "availableLanguage" : "French"
            },
            { "@type" : "ContactPoint",
              "telephone" : "+372-602-6807",
              "contactType" : "customer service",
              "availableLanguage" : "Spanish"
            },
            { "@type" : "ContactPoint",
              "telephone" : "+372-602-6854",
              "contactType" : "customer service",
              "availableLanguage" : "Italian"
            }
          ]
        }
      ]
    }</script>
  </div>
</template>

<script>
export default {
  name: 'Home-Schema'
}
</script>
